import { handleTrack } from '../../../utils/tracker';

export const StickyCTA = (): JSX.Element => {
  return (
    <div
      className="max-w-[1170px] w-full md:w-[calc(100%-48px)] lg:w-[calc(100%-48px)] sm:w-full px-12 sm:rounded-none rounded-lg py-4 sm:px-4 sm:py-3 bg-[#EFF6FF] flex items-center sticky-cta fixed z-100 shadow-md bottom-7 sm:bottom-0 left-2/4 translate-x-[-50%]"
      style={{ boxShadow: '8px 16px 32px 0px rgba(0, 0, 0, 0.15)' }}
    >
      <div className="w-full flex justify-between items-center sm:flex-col">
        <div className="text-base block sm:hidden">
          <div className="font-bold text-blue-350 text-brand-1000 w-full sm:text-s-14 sm:font-semibold">
            BIG FILING DAYS
          </div>
          <div className="text-font-500 font-semibold text-brand-1000 w-full sm:text-s-14 sm:font-semibold">
            India’s Biggest Tax Filing Festival Starts From - 12th to 14th July
          </div>
        </div>

        <div className="flex w-1/2 justify-end items-center sm:w-full sm:justify-between">
          <a
            className="text-lg sm:text-base font-medium  text-normal-case sm:w-full"
            href={`/filing/?utm_ref=big_filing_day`}
            id="sticky-cta"
            onClick={(e) => {
              handleTrack({
                label: 'big-filing-day-page',
                url: `/filing/`,
                obj: e.target,
              });
            }}
          >
            <button
              className="sm:w-full inline-flex text-center justify-center items-center font-bold focus:outline-none bg-blue-350 hover:bg-blue-450 text-white border-brand-700 rounded-sm px-20 md:px-16 py-4 sm:text-base sm:px-5 sm:py-3 transition-all"
              type="button"
            >
              Start Filing
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
